export const IS_DEBUG = false



// WEBPACK FOOTER //
// ./src/is_debug.js